
import {createSlice} from "@reduxjs/toolkit";

export const batchSlice = createSlice({
    name: 'batchSlc',
    initialState: {value: {id: 0, type: null, started: null, startReason: null, startReasonDetail: null,
        ended: null, endReason: null, endReasonDetail: null, createdOn: null, cratedBy: null, lastModifiedOn:null,lastModifiedBy:null,
            drawerState: false}},
    reducers:

{
    changeBatch: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeBatch } = batchSlice.actions;

export default  batchSlice.reducer ;


